import { Link, useNavigate } from 'react-router-dom';
import { profileHomePath } from '../../lib/routes';
import { PROFILE_LABEL, type Profile } from '../../types/profile';
import { SearchBar } from '../search/SearchBar';

interface HelpHeaderProps {
  profile?: Profile;
  onProfileChange: (profile: Profile) => void;
}

export function HelpHeader({ profile, onProfileChange }: HelpHeaderProps) {
  const navigate = useNavigate();

  function handleProfileChange(value: string) {
    const next = value as Profile;
    onProfileChange(next);
    navigate(profileHomePath(next));
  }

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link className="brand-link" to="/" aria-label="Centro de Ajuda Personagrama">
          <strong>Personagrama</strong>
          <span>Centro de Ajuda</span>
        </Link>

        <div className="header-actions">
          <Link className="header-link" to="/faq">FAQ</Link>
          <SearchBar compact />
          <div className="profile-control">
            <label className="profile-select-label" htmlFor="profile-select">Visualizando como</label>
            <select
              id="profile-select"
              className="profile-select"
              value={profile ?? ''}
              onChange={(event) => handleProfileChange(event.target.value)}
              aria-label="Selecionar perfil de ajuda"
            >
              <option value="" disabled>Escolha seu perfil</option>
              {(Object.keys(PROFILE_LABEL) as Profile[]).map((item) => (
                <option key={item} value={item}>{PROFILE_LABEL[item]}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </header>
  );
}
